import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'vant/lib/index.css';
import 'animate.css'
import 'swiper/css'
import '@/assets/js/rem'
import '@/assets/js/xinstallInit'

import './style.styl'

createApp(App).use(store).use(router).mount('#app')
